import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import useCylindoDimensionShots from 'data-hooks/useCylindoDimensionShots';
import PDPDimensionsContentUI from './PDPDimensionsContentUI';
const PDPDimensionsContent = t0 => {
  const $ = _c(16);
  const {
    isSidebarContent,
    onDimensionShotViewed,
    onImageClick,
    pageLoading: t1,
    upholsteryKey
  } = t0;
  const pageLoading = t1 === undefined ? false : t1;
  const {
    loading,
    error,
    data: t2
  } = useProductAttributes();
  const {
    dimensions,
    custom_properties,
    boxDimensions,
    boxDimensionsPending
  } = t2;
  let t3;
  if ($[0] !== upholsteryKey) {
    t3 = {
      upholsteryKey
    };
    $[0] = upholsteryKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dimensionShotsData = useCylindoDimensionShots(t3);
  const {
    setSelectedDimensionShotIndex
  } = dimensionShotsData;
  if (error) {
    return null;
  }
  const t4 = loading || pageLoading;
  const t5 = custom_properties?.dimensional_image_desktop;
  const t6 = custom_properties?.dimensional_image_mobile;
  let t7;
  if ($[2] !== onDimensionShotViewed || $[3] !== setSelectedDimensionShotIndex) {
    t7 = index => {
      setSelectedDimensionShotIndex(index);
      onDimensionShotViewed?.(index);
    };
    $[2] = onDimensionShotViewed;
    $[3] = setSelectedDimensionShotIndex;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== boxDimensions || $[6] !== boxDimensionsPending || $[7] !== dimensionShotsData || $[8] !== dimensions || $[9] !== isSidebarContent || $[10] !== onImageClick || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <PDPDimensionsContentUI loading={t4} dimensionsDesktopImage={t5} dimensionsMobileImage={t6} dimensions={dimensions} boxDimensions={boxDimensions} boxDimensionsPending={boxDimensionsPending} onImageClick={onImageClick} isSidebarContent={isSidebarContent} {...dimensionShotsData} setSelectedDimensionShotIndex={t7} />;
    $[5] = boxDimensions;
    $[6] = boxDimensionsPending;
    $[7] = dimensionShotsData;
    $[8] = dimensions;
    $[9] = isSidebarContent;
    $[10] = onImageClick;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
PDPDimensionsContent.propTypes = {
  isSidebarContent: PropTypes.bool,
  // Set only by the mobile Measure modal; the Dimensions sections don't track
  onDimensionShotViewed: PropTypes.func,
  onImageClick: PropTypes.func,
  pageLoading: PropTypes.bool,
  upholsteryKey: PropTypes.string
};
export default PDPDimensionsContent;